import { render, staticRenderFns } from "./ReportItem.vue?vue&type=template&id=08c71640"
import script from "./ReportItem.vue?vue&type=script&lang=js"
export * from "./ReportItem.vue?vue&type=script&lang=js"
import style0 from "./ReportItem.vue?vue&type=style&index=0&id=08c71640&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports